/**
 * Configurations related to all the endpoint methods (except a few)
*/
import axios from "axios";
import Csrf from "./Csrf";

let Api = axios.create({
  baseURL: (typeof window === 'undefined') ? 'https://localhost.sparkfore.com/l/api' : process.env.VUE_APP_API_BASE_URL // 'https://localhost.sparkfore.com/l/api' //
});

async function getHeaderConfig(config) {

  switch (config) {
    case "MOODLE_SESSION_JSON": {

      const moodleSession = await Csrf.getCookie();
      return {
        headers: {
          Authorization: (typeof window === 'undefined') ? null : 'Bearer ' + localStorage.getItem('token'),
          MoodleSession: moodleSession,
          'Content-Type': 'application/json'
        }
      };
    }
    case "COOKIE_TOKEN_JSON": {
      return {
        headers: {
          Authorization: (typeof window === 'undefined') ? null : 'Bearer ' + localStorage.getItem('token'),
          'Content-Type': 'application/json'
        }
      };
    }
    case "COOKIE_TOKEN": {

      return {
        headers: {
          Authorization: (typeof window === 'undefined') ? null : 'Bearer ' + localStorage.getItem('token'),
        }
      };
    }
    case "COOKIE_TOKEN_SESSION": {

      const moodleSession = await Csrf.getCookie();
      return {
        headers: {
          Authorization: (typeof window === 'undefined') ? null : 'Bearer ' + localStorage.getItem('token'),
          MoodleSession: moodleSession
        }
      }
    }
    case "PLAIN_JSON": {
      return {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }

    case "MOODLE_REST_API_JSON" : {
      return {
        headers : {
          'Content-Type': 'application/json',
          'Authorization' : "58de6ed375ad8b81f6968f1cc6304c79",
          'Accept' : 'application/json'
        }
      }
    }

    default:
      return config;

  }
}

export default {

  async post(url, data, config = null) {

    if (typeof data !== 'object') {
      data = JSON.parse(data);
    }

    return Api.post(url, data, await getHeaderConfig(config))
  },
  async put(url, data, config = null) {
    return Api.put(url, data, await getHeaderConfig(config))
  },
  async get(url, config = null) {
    return Api.get(url, await getHeaderConfig(config))
  }

}
